export enum DocumentTypeId {
    CONTRACT_PROOF = '1',
    DNI = '2',
    NIF = '3',
    CIF = 'CI',
    NIE = '7',
    NIE_NOT_RESIDENT = '6',
    IDENTIFICATION_CARD_NOT_RESIDENT = 'TR',
    IDENTIFICATION_DOCUMENT = '12',
    ORIGIN_FUNDS = '27',
    PASSPORT = '10',
    PASSPORT_LATIN = '9',
    PERMISSION = 'PR',
    INVERSIS = '20',
    DNI_FRONT_SIDE = '21',
    DNI_BACK_SIDE = '22',
    NIE_NOT_RESIDENT_FRONT_SIDE = '23',
    NIE_NOT_RESIDENT_BACK_SIDE = '24',
    NIE_FRONT_SIDE = '25',
    NIE_BACK_SIDE = '26',
}
